import { Phone, Star, Shield, Clock } from 'lucide-react';

export const Hero = () => {
  return (
    <section 
      className="hero-overlay relative min-h-[90vh] flex items-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?crop=entropy&cs=srgb&fm=jpg&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      data-testid="hero-section"
    >
      <div className="hero-content max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="max-w-3xl">
          {/* Trust Badge */}
          <div className="trust-badge mb-8 fade-up">
            <Star className="fill-yellow-400 text-yellow-400" size={18} />
            <span className="text-white font-semibold">4.9/5 Stars on Google</span>
            <span className="text-white/50">|</span>
            <Shield size={16} className="text-green-400" />
            <span className="text-white/80">Licensed & Insured</span>
          </div>

          {/* Headline */}
          <h1 
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight fade-up-delay-1"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Same-Day Appliance Repair in Toronto & GTA
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-white/90 mb-8 leading-relaxed fade-up-delay-2 max-w-2xl">
            Expert repairs for Fridges, Washers, Dryers, and Ovens. Certified technicians at your door in 2 hours or less. Serving Vaughan, Richmond Hill, Markham & beyond.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 fade-up-delay-3">
            <a
              href="tel:647-919-6893"
              className="pulse-cta inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full font-bold text-lg text-white transition-transform hover:scale-105 shadow-xl"
              style={{ background: '#FF6B00', fontFamily: 'Montserrat, sans-serif' }}
              data-testid="hero-call-button"
            >
              <Phone size={22} />
              <span>Call 647-919-6893</span>
            </a>
            <a
              href="tel:647-919-6893"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full font-bold text-lg text-white border-2 border-white/30 hover:bg-white/10 transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
              data-testid="hero-book-button"
            >
              <span>Book Same-Day Service</span>
            </a>
          </div>

          {/* Quick Features */}
          <div className="flex flex-wrap gap-6 text-white/80">
            <div className="flex items-center gap-2">
              <Clock size={18} className="text-[#FF6B00]" />
              <span>2-Hour Arrival</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield size={18} className="text-[#FF6B00]" />
              <span>All Major Brands</span>
            </div>
            <div className="flex items-center gap-2">
              <Star size={18} className="text-[#FF6B00]" />
              <span>150+ 5-Star Reviews</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
